import { NavigateNext } from '@mui/icons-material'
import { Box, Button, Card, Container, Divider, Step, StepLabel, Stepper } from '@mui/material'
import React, { ChangeEvent, useEffect, useState } from 'react'
import RegisterAccess from '../../../../utils/registerAccess'
import HeaderSession from '../../../../utils/headerSession'
import { useDispatch } from 'react-redux'
import DadosUnidade from './stepsFormQualidadeProduto/stepDadosUnidade'
import IdentificaçãoProduto from './stepsFormQualidadeProduto/stepIdentificaçãoProduto'
import ProdutoDefeitos from './stepsFormQualidadeProduto/stepProdutoDefeitos'
import ArmazenamentoSituacao from './stepsFormQualidadeProduto/stepArmazenamentoSituacao'
import Notificador from './stepsFormQualidadeProduto/stepNotificador'
import api from '../../../../services/api'
import MessageError from '../../../../messages/messageError'
import LoadingShort from '../../../../load/loadingShort'
import SuccessMessage from '../controleQualidade/components/SuccessMessage'

interface FormData {
    _id: string;
    unidadeSanitaria: string;
    provincia: string;
    distrito: string;
    bairro: string;
    rua: string;
    email: string;
    nomeProduto: string;
    nomeComercial: string;
    numeroLote: string;
    dataFabrico: string;
    dataExpiracao: string;
    nomeFabricante: string;
    paisOrigem: string;
    fornecedor: string;
    dataRecepcao: string;
    nomeNotificador: string;
    catProfissionalNotificador: string;
    telFaxNotificador: string;
    emailNotificador: string;
}

interface Estabelecimento {
    empresa: {
        nome: string;
        provincia: string;
        municipio: string;
        bairro: string;
        rua: string;
        email: string;
    }
}

const NotificacaoProdutoBaixaQualidade = () => {
    const steps = [
        'Dados da Unidade Sanitária',
        'Identificação do Produto',
        'Apresentação do Produto e Defeitos',
        'Armazenamento e Situação',
        'Notificador',
    ];

    const dispatch = useDispatch();
    const [activeStep, setActiveStep] = useState(0);
    const [estabelecimento, setEstabelecimento] = useState<Estabelecimento>();
    const [searchTerm, setSearchTerm] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [messageError, setMessageError] = useState('');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [load, setLoad] = useState(false);
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    // "O campo identificacaoProductoApresentacaoProductoOutros é obrigatório"
    const [formData, setFormData] = useState<FormData>({
        _id: '',
        unidadeSanitaria: '',
        provincia: '',
        distrito: '',
        bairro: '',
        rua: '',
        email: '',
        nomeProduto: '',
        nomeComercial: '',
        numeroLote: '',
        dataFabrico: '',
        dataExpiracao: '',
        nomeFabricante: '',
        paisOrigem: '',
        fornecedor: '',
        dataRecepcao: '',
        nomeNotificador: '',
        catProfissionalNotificador: '',
        telFaxNotificador: '',
        emailNotificador: '',
    });

    const [apresentacaoState, setApresentacaoState] = useState({
        identificacaoProductoApresentacaoProductoA: false,
        identificacaoProductoApresentacaoProductoB: false,
        identificacaoProductoApresentacaoProductoC: false,
        identificacaoProductoApresentacaoProductoD: false,
        identificacaoProductoApresentacaoProductoE: false,
        identificacaoProductoApresentacaoProductoF: false,
        identificacaoProductoApresentacaoProductoG: false,
        identificacaoProductoApresentacaoProductoH: false,
        identificacaoProductoApresentacaoProductoI: false,
        identificacaoProductoApresentacaoProductoJ: false,
        identificacaoProductoApresentacaoProductoK: false,
        identificacaoProductoApresentacaoProductoOutros: '',
        identificacaoProductoDefeitosA: false,
        identificacaoProductoDefeitosB: false,
        identificacaoProductoDefeitosC: false,
        identificacaoProductoDefeitosD: false,
        identificacaoProductoDefeitosE: false,
        identificacaoProductoDefeitosF: false,
        identificacaoProductoDefeitosG: false,
        identificacaoProductoDefeitosH: false,
        identificacaoProductoDefeitosI: false,
        identificacaoProductoDefeitosOutros: ''
    });

    const [respostas, setRespostas] = useState({
        requerRefrigeracao: '',
        jaFoiUsado: '',
        foiDevolvido: '',
        defeitoDetectado: '',
        armazenadoCorretamente: '',
        conducoesArmazenamentoOutrosDetalhes:''
    });


    const handleResposta = (key: string, valor: string) => {
        setRespostas(prev => ({ ...prev, [key]: valor }));
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        setApresentacaoState(prev => ({ ...prev, [name]: checked }));
    };

    const handleOutrosChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setApresentacaoState(prev => ({
            ...prev, [event.target.name]: event.target.value,
        }));
    };
    const handleOutrosResposta = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRespostas(prev => ({
            ...prev, [event.target.name]: event.target.value,
        }));
    };

    useEffect(() => {
        dispatch({
            type: 'dadosProduto',
            payload: { dadosProduto: formData }
        });
    }, [formData, dispatch]);

    const buscarEstabelecimento = () => {
        if (!searchTerm) return;
        setLoading(true)
        api.post('/estabelecimento/search', { search: searchTerm })
            .then((res) => {
                console.log(res.data)
                res.data.estabelecimentos.length === 0 ?
                    setMessageError("Estabelecimento não registrado, preencha os campos abaixo:")
                    : setFormData({
                        _id: res.data.estabelecimentos?.[0]?._id ?? '',
                        unidadeSanitaria: res.data.estabelecimentos?.[0]?.empresa?.nome ?? '',
                        provincia: res.data.estabelecimentos?.[0]?.empresa?.provincia ?? '',
                        distrito: res.data.estabelecimentos?.[0]?.empresa?.municipio ?? '',
                        bairro: res.data.estabelecimentos?.[0]?.empresa?.bairro ?? '',
                        rua: res.data.estabelecimentos?.[0]?.empresa?.rua ?? '',
                        email: res.data.estabelecimentos?.[0]?.empresa?.email ?? '',
                        nomeProduto: '',
                        nomeComercial: '',
                        numeroLote: '',
                        dataFabrico: '',
                        dataExpiracao: '',
                        nomeFabricante: '',
                        paisOrigem: '',
                        fornecedor: '',
                        dataRecepcao: '',
                        nomeNotificador: '',
                        catProfissionalNotificador: '',
                        telFaxNotificador: '',
                        emailNotificador: ''
                    })
                setShow(true);
            })
            .catch((err) => {
                console.log(err);
                setMessageError(err.response.data.message)
            })
            .finally(() => setLoading(false));
    }

    function getStepContent(stepIndex: number) {
        switch (stepIndex) {
            case 0:
                return <DadosUnidade formData={formData} handleChange={handleChange} buscarEstabelecimento={buscarEstabelecimento} searchTerm={searchTerm} loading={loading} setSearchTerm={setSearchTerm} messageError={messageError} show={show} />;
            case 1:
                return <IdentificaçãoProduto formData={formData} handleChange={handleChange} />;
            case 2:
                return <ProdutoDefeitos
                    apresentacaoState={apresentacaoState}
                    handleCheckboxChange={handleCheckboxChange}
                    handleOutrosChange={handleOutrosChange}
                />;
            case 3:
                return <ArmazenamentoSituacao Respostas={respostas} handleResposta={handleResposta} handleOutrosResposta={handleOutrosResposta} />;
            case 4:
                return <Notificador formData={formData} handleChange={handleChange} />;
            default:
                return <DadosUnidade formData={formData} handleChange={handleChange} buscarEstabelecimento={buscarEstabelecimento} searchTerm={searchTerm} loading={loading} setSearchTerm={setSearchTerm} messageError={messageError} show={show} />;
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const submitFicha = async () => {
        setLoad(true);
        api.post('/farmaco-vigilancia/create/NSPBQ', {
            'estabelecimentoId': formData._id,
            'unidadeSanitariaNome': formData.unidadeSanitaria,
            'unidadeSanitariaProvincia': formData.provincia,
            'unidadeSanitariaBairro': formData.bairro,
            'unidadeSanitariaRua': formData.rua,
            'unidadeSanitariaEmail': formData.email,

            'identificacaoProductoNomeDCI': formData.nomeProduto,
            'identificacaoProductoNomeCormecial': formData.nomeComercial,
            'identificacaoProductoNumeroLote': formData.numeroLote,
            'identificacaoProductoDataFabrico': formData.dataFabrico,
            'identificacaoProductoDataExpiracao': formData.dataExpiracao,
            'identificacaoProductoDataRecepcao': formData.dataRecepcao,
            'identificacaoProductoNomeFabricante': formData.nomeFabricante,
            'identificacaoProductoNomeFornecedor': formData.fornecedor,

            'identificacaoProductoApresentacaoProductoA': apresentacaoState.identificacaoProductoApresentacaoProductoA,
            'identificacaoProductoApresentacaoProductoB': apresentacaoState.identificacaoProductoApresentacaoProductoB,
            'identificacaoProductoApresentacaoProductoC': apresentacaoState.identificacaoProductoApresentacaoProductoC,
            'identificacaoProductoApresentacaoProductoD': apresentacaoState.identificacaoProductoApresentacaoProductoD,
            'identificacaoProductoApresentacaoProductoE': apresentacaoState.identificacaoProductoApresentacaoProductoE,
            'identificacaoProductoApresentacaoProductoF': apresentacaoState.identificacaoProductoApresentacaoProductoF,
            'identificacaoProductoApresentacaoProductoG': apresentacaoState.identificacaoProductoApresentacaoProductoG,
            'identificacaoProductoApresentacaoProductoH': apresentacaoState.identificacaoProductoApresentacaoProductoH,
            'identificacaoProductoApresentacaoProductoI': apresentacaoState.identificacaoProductoApresentacaoProductoI,
            'identificacaoProductoApresentacaoProductoJ': apresentacaoState.identificacaoProductoApresentacaoProductoJ,
            'identificacaoProductoApresentacaoProductoK': apresentacaoState.identificacaoProductoApresentacaoProductoK,
            'identificacaoProductoApresentacaoProductoOutros': apresentacaoState.identificacaoProductoApresentacaoProductoOutros,

            'identificacaoProductoDefeitosA': apresentacaoState.identificacaoProductoDefeitosA,
            'identificacaoProductoDefeitosB': apresentacaoState.identificacaoProductoDefeitosB,
            'identificacaoProductoDefeitosC': apresentacaoState.identificacaoProductoDefeitosC,
            'identificacaoProductoDefeitosD': apresentacaoState.identificacaoProductoDefeitosD,
            'identificacaoProductoDefeitosE': apresentacaoState.identificacaoProductoDefeitosE,
            'identificacaoProductoDefeitosF': apresentacaoState.identificacaoProductoDefeitosF,
            'identificacaoProductoDefeitosG': apresentacaoState.identificacaoProductoDefeitosG,
            'identificacaoProductoDefeitosH': apresentacaoState.identificacaoProductoDefeitosH,
            'identificacaoProductoDefeitosI': apresentacaoState.identificacaoProductoDefeitosI,
            'identificacaoProductoDefeitosOutros': apresentacaoState.identificacaoProductoDefeitosOutros,

            'conducoesArmazenamentoAResposta': respostas.requerRefrigeracao,
            'conducoesArmazenamentoBResposta': respostas.jaFoiUsado,
            'conducoesArmazenamentoCResposta': respostas.foiDevolvido,
            'conducoesArmazenamentoDResposta': respostas.defeitoDetectado,
            'conducoesArmazenamentoEResposta': respostas.armazenadoCorretamente,
            'conducoesArmazenamentoFResposta': 'Sim',
            'conducoesArmazenamentoAOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,
            'conducoesArmazenamentoBOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,
            'conducoesArmazenamentoCOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,
            'conducoesArmazenamentoDOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,
            'conducoesArmazenamentoEOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,
            'conducoesArmazenamentoFOutrosDetalhes': respostas.conducoesArmazenamentoOutrosDetalhes,

            'notificadorNome': formData.nomeNotificador,
            'notificadorCategoriaProfissional': formData.catProfissionalNotificador,
            'notificadorTel': formData.telFaxNotificador,
            'notificadorEmai': formData.emailNotificador,
        })
            .then((res) => {
                setSuccessMessage(res?.data?.msg);
                setShowSuccessCard(true)
                setLoad(false);
            })
            .catch((error) => {
                console.log(error);
                setMessageError(error?.response?.data?.message || 'Erro ao processar solicitação');
                setLoad(false);
            })
    };

    const stepValidations: { [key: number]: () => boolean } = {
        0: () =>
            formData.unidadeSanitaria.trim() !== '' &&
            formData.provincia.trim() !== '' &&
            formData.distrito.trim() !== '' &&
            formData.rua.trim() !== '' &&
            formData.email.trim() !== '',
        1: () =>
            formData.nomeProduto.trim() !== '' &&
            formData.nomeComercial.trim() !== '' &&
            formData.numeroLote.trim() !== '' &&
            formData.dataFabrico.trim() !== '' &&
            formData.dataExpiracao.trim() !== '' &&
            formData.nomeFabricante.trim() !== '' &&
            formData.paisOrigem.trim() !== '' &&
            formData.fornecedor.trim() !== '' &&
            formData.dataRecepcao.trim() !== '',
        3: () =>
            respostas.requerRefrigeracao.trim() !== '' &&
            respostas.jaFoiUsado.trim() !== '' &&
            respostas.foiDevolvido.trim() !== '' &&
            respostas.defeitoDetectado.trim() !== '' &&
            respostas.armazenadoCorretamente.trim() !== '',
        4: () =>
            formData.nomeNotificador.trim() !== '' &&
            formData.catProfissionalNotificador.trim() !== '' &&
            formData.telFaxNotificador.trim() !== '' &&
            formData.emailNotificador.trim() !== '',
    };

    const isStepValid = (step: number): boolean => {
        return stepValidations[step]?.() ?? true;
    };


    return (
        <Container style={{ marginBottom: 12, minHeight: '72vh' }}>
            <RegisterAccess page={'Ficha de Notificação de Produtos com Baixa Qualidade'} />
            <HeaderSession title='FICHA DE NOTIFICAÇÕES DE PRODUTOS COM BAIXA QUALIDADE' />
            {showSuccessCard ?
                <SuccessMessage message='Notificação Enviada com Sucesso!' />
                :
                <Card style={{ marginBottom: 12, padding: 22 }}>

                    {/* <LoadingBackdrop open={open} /> */}
                    {messageError && <MessageError message={messageError} />}

                    <div style={{ overflow: 'auto' }}>
                        <Stepper color="secondary" activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label} >
                                    <StepLabel style={{ color: '#85287e' }}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Divider />
                    </div>

                    <Box sx={{ marginTop: 6 }}>{getStepContent(activeStep)}</Box>

                    <div style={{ display: 'flex', margin: '20px 10px' }}>
                        <Button
                            style={{ background: '#ebebf4' }}
                            variant="outlined"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                        >
                            Voltar
                        </Button>

                        <Box style={{ display: 'flex', flexGrow: 1 }} />

                        {activeStep === steps.length - 1 ? (
                            <Button
                                style={{ background: '#85287e', width: 120 }}
                                variant="contained"
                                onClick={submitFicha}
                                disabled={!isStepValid(activeStep)}
                            >
                                {load ? <LoadingShort text={''} /> : 'Enviar'}
                            </Button>
                        ) : (
                            <Button
                                style={{ background: '#85287e', width: 120 }}
                                variant="contained"
                                onClick={handleNext}
                                disabled={!isStepValid(activeStep)}
                            >
                                Próximo <NavigateNext />
                            </Button>
                        )}
                    </div>
                </Card>}
        </Container>
    )
}

export default NotificacaoProdutoBaixaQualidade
